module.exports = __webpack_public_path__ + "img/honeytalk.0af3ae51.png";